import PulseLoader from "react-spinners/PulseLoader";
import Logo from "../navigation/img/logo.png";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <img src={Logo} alt="Client Logo" className="logo-loader" />
        <PulseLoader color="#3498db" size={10} />
      </div>
    </div>
  );
};

export default Loader;
